import { BLOCKS } from '@contentful/rich-text-types';
import React, { useRef } from 'react';

import MarketoForm from '../../components/Common/MarketoForm/MarketoForm';
import * as embeddedEntries from '../../components/Common/RichText/EmbeddedEntries';
import RichTextConverter from '../../components/Common/RichText/RichTextConverter';
import { scrollToFormTop } from '../../components/Common/ScrollTo';
import PageSection from '../../components/PageSections/PageSection';
import { getThemeClass } from '../textTools';

const MarketoFormSection = ({ section, styles, scrollRef, headingCtaScrollsToForm }) => {
  const topOfFormRef = useRef(null);
  const onFormSuccess = async () => {
    scrollToFormTop(topOfFormRef);
  };
  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: (node) => {
        const type = node?.data?.target?.internal?.type;
        if (type === 'ContentfulComponentMediaGroup') {
          return embeddedEntries.simpleMediaGroup(node, styles.logoGridSmall);
        }
      },
    },
  };

  let form = (
    <MarketoForm
      data-analytics-section={'form'}
      onSuccess={onFormSuccess}
      redirectUrl={section.onSuccessRedirectUrl}
      formId={section.marketoFormId}
      successMessage={section.formSuccessMessage}
      productOfInterest={section.productOfInterest}
    />
  );

  const backgroundColors = {
    Grey: styles.grey,
    White: styles.white,
    Evergreen: styles.evergreen,
    'Dark Blue Gradient': styles.darkBlueGradient,
    'Spark Pink Gradient': styles.sparkPinkGradient,
    'Multicolor Gradient': styles.multicolorGradient,
  };

  const themeClass = getThemeClass(section.colorTheme?.themeName);

  return (
    <>
      {headingCtaScrollsToForm && <div ref={scrollRef} id={'marketo-form'} />}
      <PageSection
        moderate
        backgroundImage={section.backgroundImage}
        className={[section.backgroundColor ? backgroundColors[section.backgroundColor] : styles.grey, themeClass].join(
          ' '
        )}
        data-analytics-section={'form-wrapper'}
      >
        <div className={styles.form}>
          <div className={styles.formCopy} data-analytics-component={'form-copy'}>
            <RichTextConverter copy={section?.formCopy} options={options} />
          </div>
          <div
            data-analytics-component={'marketo-form'}
            data-analytics-id={section.marketoFormId}
            id={'mkto-form-wrap'}
            ref={topOfFormRef}
            className={section.backgroundColor === 'Dark Blue Gradient' ? styles.formWhite : ''}
          >
            {form}
          </div>
        </div>
      </PageSection>
    </>
  );
};

export const ContentfulSectionMarketoForm = (page, section, i, styles, scrollRef = { current: undefined }) => {
  return (
    <MarketoFormSection
      key={i}
      headingCtaScrollsToForm={page.headingCtaScrollsToForm}
      section={section}
      styles={styles}
      scrollRef={scrollRef}
    />
  );
};
